import styled from "@emotion/styled";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Box, Link } from "@mui/joy";
import { Header as HeaderType, flexRender } from "@tanstack/react-table";

import { Route } from "../../core/types";
import { TableType } from "../RoutesProvider/RoutesProvider";
import FilterPopup from "./FilterPopup";
import { useRoutesTableStore } from "./RoutesProvider2";
import { isValidFilterName } from "./useFilteredRoutes";

const StyledTh = styled.th`
  display: flex;
  align-items: center;
  gap: 1;
  &.active {
    background: #e5efff;
    position: relative;
    border: 1px solid #0084ff;
    border-bottom-width: 1px !important;
  }
`;

export default function TableHeader({
  header,
  table,
}: {
  header: HeaderType<Route, unknown>;
  table: TableType;
}) {
  const isSorted = header.column.getIsSorted();
  const filterParams = useRoutesTableStore((state) => state.filterParams);
  const filterName =
    (header.column.columnDef.meta?.["filterName"] as string | undefined) || header.column.id;

  const filterIsActive = isValidFilterName(filterName) && filterParams[filterName] !== undefined;
  const clickHandler = header.column.getToggleSortingHandler();

  return (
    <StyledTh
      className={filterIsActive ? "active" : ""}
      key={header.id}
      style={{
        width: header.getSize(),
      }}
    >
      <Link
        underline="none"
        textColor={header.column.getIsSorted() || filterIsActive ? "primary.500" : "neutral.800"}
        onClick={clickHandler}
        startDecorator={
          isSorted ? (
            isSorted === "desc" ? (
              <ArrowDownward sx={{ fontSize: "16px" }} />
            ) : (
              <ArrowUpward sx={{ fontSize: "16px" }} />
            )
          ) : null
        }
        sx={{
          flex: 1,
          ".MuiLink-startDecorator": {
            marginInlineEnd: 0,
          },
        }}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
      </Link>
      {header.column.columnDef.enableColumnFilter !== false && (
        // <FilterMenu column={header.column} table={table} />
        <Box sx={{ marginRight: -1 }}>
          <FilterPopup column={header.column} table={table} />
        </Box>
      )}
    </StyledTh>
  );
}
